export default __webpack_public_path__ + "static/media/gear_1.321d7804.png";